export default {
    READY: 0,
    UPLOADING: 1,
    SUCCESS: 2,
    FAIL: 3,
    CANCELLED: 4,
    // 失效,超过24小时未操作续传
    EXPIRED: 5,
};
